import { Component, OnInit, Input } from "@angular/core";
import { CtaButtonLayoutInternetDataContext } from "./cta-button-layout-internet-data.models";
import { CTAButtonLayout } from "../cta-button-layout";
import { Pipe, PipeTransform } from "@angular/core";

@Component({
    selector: "dodo-cta-button-layout-internet-data",
    templateUrl: "./cta-button-layout-internet-data.component.html",
    styleUrls: ["./cta-button-layout-internet-data.component.scss"],
    standalone: false
})
export class CtaButtonLayoutInternetDataComponent
	extends CTAButtonLayout
	implements OnInit {
	@Input() title: string;
	@Input() iconImage: string;
	@Input() titleNote: string;
	@Input() subtitle: string;
	@Input() price: number;
	@Input() afterPriceText: string;
	@Input() promoDiscountValue: number;
	@Input() promoDiscountDuration: string;
	@Input() promoEndDate: Date;
	@Input() marketing: {
		text: string;
		textDecoration: string;
	};

	@Input() set context(ctx: CtaButtonLayoutInternetDataContext) {
		if (ctx) {
			this.__updatePropertyFromContext(ctx);
		}
	}

	set layoutContext(ctx: CtaButtonLayoutInternetDataContext) {
		if (ctx) {
			this.__updatePropertyFromContext(ctx);
		}
	}

	private __updatePropertyFromContext(
		ctx: CtaButtonLayoutInternetDataContext
	) {
		this.title = this.title || ctx.title;
		this.iconImage = this.iconImage || ctx.iconImage;
		this.titleNote = this.titleNote || ctx.titleNote;
		this.price = this.price || ctx.price;
		this.promoDiscountValue =
			this.promoDiscountValue || ctx.promoDiscountValue;
		this.promoDiscountDuration =
			this.promoDiscountDuration || ctx.promoDiscountDuration;
		this.subtitle = this.subtitle || ctx.subtitle;
		this.afterPriceText = this.afterPriceText || ctx.afterPriceText;
		this.marketing = this.marketing || ctx.marketing;
	}

	constructor() {
		super();
	}

	ngOnInit() {}
}
